<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import ApprovalModal from "../ApprovalModal.vue";
import moment from "moment";
export default {
  components: { ApprovalModal },
  name: "ReadyToFilmList",
  data() {
    return {
      sorting: "",
      activities: [],
      limit: 25,
      currentPageNumber: 1,
      searchStr: null,
      searchResult: true,
      rows: 3,
      pagedBy: 5,
      fields: [
        {
          key: "type",
          sortable: true,
        },
        {
          key: "uid",
          sortable: true,
          label: "ID",
        },
        {
          key: "working_title",
          label: "Working Title",
          sortable: true,
        },
        {
          key: "series",
          sortable: true,
        },
        {
          key: "output",
          label: "Output Type",
          sortable: true,
        },
        {
          key: "location",
          label: "Publish Location",
          sortable: true,
        },
        {
          key: "status",
          label: "Last Edited",
          sortable: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      currentPaginationPage: "commons/currentPaginationPage",
      currentDataList: "commons/currentDataList",
      fieldOptionsChunked: "commons/fieldOptionsChunked",
    }),
  },
  mounted() {
    this.$store.dispatch(`commons/getFieldOptions`);
    var args = {
      limit: 25,
      type: "todo",
      status: "produced",
      offset: 1,
    };

    if (this.searchStr) {
      args["search"] = this.searchStr;
    }
    if (this.sorting) {
      args["sorting"] = this.sorting;
    }

    this.fetchData(args, 1);
  },
  methods: {
    dateStatus(date) {
      return moment(date).fromNow();
    },
    openApproval(activity, status) {
      this.$store.commit(`commons/setActivity`, activity);
      this.$store.commit(`commons/setOpenedApproval`, true);
      this.$store.commit(`commons/setStatusApproval`, status);
    },
    optionValue(id, type) {
      const data =
        this.fieldOptionsChunked[type] && id
          ? this.fieldOptionsChunked[type].find((option) => option.id == id)
          : null;

      if (data) return data.label;
    },
    convertType(type) {
      return type == "stretch_flow" ? "stretch-flow" : type;
    },
    countPage() {
      if (this.activities.count)
        return Math.ceil(this.activities.count / this.limit);
    },
    fetchData(args, page) {
      this.searchResult = true;
      this.$store.commit("commons/setPreloader", true);
      this.$store.dispatch("commons/listByType", args).then(
        (res) => {
          this.activities = res;
          this.$store.commit("commons/setPreloader", false);
        },
        (error) => {
          this.$store.commit("commons/setPreloader", false);
          console.log(error);
        }
      );
      this.$store.commit("commons/setCurrentPaginationPage", page);
    },
    sortingFunc(ctx) {
      this.activities.results = [];
      this.sorting = ctx.sortDesc ? "-" : "";
      var sortby =
        ctx.sortBy == "working_title" ||
        ctx.sortBy == "type" ||
        ctx.sortBy == "created"
          ? ctx.sortBy
          : ctx.sortBy + "__label";

      this.sorting = this.sorting + sortby;

      var args = {
        limit: this.limit,
        type: "todo",
        status: "produced",
        offset: this.currentPageNumber,
      };

      if (this.searchStr) {
        args["search"] = this.searchStr;
      }
      if (this.sorting) {
        args["sorting"] = this.sorting;
      }

      this.fetchData(args, this.currentPageNumber);
    },
    page(number) {
      this.currentPageNumber = number;
      var args = {
        limit: this.limit,
        type: "todo",
        status: "produced",
        offset: this.currentPageNumber,
      };

      if (this.searchStr) {
        args["search"] = this.searchStr;
      }
      if (this.sorting) {
        args["sorting"] = this.sorting;
      }

      this.fetchData(args, this.currentPageNumber);
    },
    next() {
      this.currentPageNumber = this.currentPageNumber + 1;
      var args = {
        limit: this.limit,
        type: "todo",
        status: "produced",
        offset: this.currentPageNumber,
      };
      if (this.searchStr) {
        args["search"] = this.searchStr;
      }
      if (this.sorting) {
        args["sorting"] = this.sorting;
      }

      this.fetchData(args, this.currentPageNumber);
    },
    prev() {
      this.currentPageNumber = this.currentPageNumber - 1;
      var args = {
        limit: this.limit,
        type: "todo",
        status: "produced",
        offset: this.currentPageNumber,
      };

      if (this.searchStr) {
        args["search"] = this.searchStr;
      }
      if (this.sorting) {
        args["sorting"] = this.sorting;
      }

      this.fetchData(args, this.currentPageNumber);
    },
    changelimit() {
      var args = {
        limit: this.limit,
        type: "todo",
        status: "produced",
        offset: this.currentPageNumber,
      };

      if (this.searchStr) {
        args["search"] = this.searchStr;
      }
      if (this.sorting) {
        args["sorting"] = this.sorting;
      }

      this.fetchData(args, this.currentPageNumber);
    },
    search() {
      var args = {
        limit: this.limit,
        type: "todo",
        status: "produced",
        offset: 1,
      };

      if (this.searchStr) {
        args["search"] = this.searchStr;
      }
      if (this.sorting) {
        args["sorting"] = this.sorting;
      }

      this.fetchData(args, 1);
    },
    clearSearch() {
      if (!this.searchStr) {
        this.search();
      }
    },
    clearSearchClick() {
      this.searchStr = "";
      this.search();
    },
    makeToast(variant = null, title, message) {
      this.$bvToast.toast(message, {
        title: `${title || "default"}`,
        variant: variant,
        solid: true,
        toaster: "b-toaster-bottom-right",
      });
    },
    updateStatus(activity, status) {
      this.$store.commit("commons/setPreloader", true);
      this.$store.commit(`commons/setActivity`, activity);
      this.$store.commit(`commons/setActivityStatus`, status);
      this.$store.dispatch(`commons/updateActivity`, activity.id).then(
        (res) => {
          // this.makeToast("success", "Success", `Succesfully saved.`);
          this.$store.commit(`commons/setSavingForm`, "Saved");
          this.$store
            .dispatch("commons/listByType", {
              type: "todo",
              status: "produced",
              offset: 1,
              search: null,
              limit: this.limit,
            })
            .then(
              (res) => {
                this.$store.commit("commons/setPreloader", false);
              },
              (error) => {
                console.log(error);
              }
            );
        },
        (error) => {
          console.log(error);
        }
      );
    },
    scriptBuilder(activity) {
      this.$store.commit("scripts/setOpened", true);
      this.$store.commit(`commons/setActivity`, activity);
    },

    openActivity(activity, index) {
      this.$router.push(
        `/update-${this.convertType(activity.type)}/${activity.id}`
      );
    },
  },
};
</script>
<style lang="scss">
.publish {
  tbody {
    td {
      &:last-child {
        width: 510px;
        text-align: right;
        .status {
          width: 290px;
          display: inline-block;
          text-align: right;
        }
      }
    }
  }
}
</style>
<template>
  <div class="data-list publish">
    <div class="filter d-flex align-items-center">
      <b-input-group>
        <b-form-input
          v-model="searchStr"
          type="text"
          placeholder="Search workouts by name, status, …"
          v-on:keyup.enter="search"
        ></b-form-input>
        <b-input-group-append>
          <b-input-group-text class="mr-2">
            <b-icon icon="search" v-if="!searchStr" />
            <b-icon
              icon="x-circle-fill"
              class="text-danger cursor-pointer"
              @click="clearSearchClick()"
              v-if="searchStr"
            />
          </b-input-group-text>
        </b-input-group-append>
      </b-input-group>
      <b-input-group-append>
        <b-button
          text="Button"
          variant="primary bg-white text-primary"
          @click="search()"
          >FILTER</b-button
        >
      </b-input-group-append>
    </div>
    <b-table
      @sort-changed="sortingFunc"
      :sticky-header="true"
      responsive
      :fields="fields"
      :items="activities.results"
      v-if="searchResult"
    >
      <template #cell(working_title)="data">
        <b
          ><a
            v-bind:href="`#/update-${convertType(data.item.type)}/${
              data.item.id
            }`"
            >{{ data.item.working_title }}</a
          ></b
        >
      </template>

      <template #cell(type)="data">
        <span class="badge inline-block type" :class="data.item.status">{{
          data.item.type
        }}</span>
      </template>

      <template #cell(series)="data"
        ><span>{{ optionValue(data.item.series, "SRS") }}</span></template
      >
      <template #cell(status)="data">
        <span class="timestamp">{{ dateStatus(data.item.modified) }}</span>
        <span
          class="d-inline-block text-primary text-uppercase cursor-pointer"
          @click="openApproval(data.item, 'published')"
          v-if="
            (data.item.filming_complete && data.item.with_equipment != null) ||
            (data.item.has_script && data.item.with_equipment != null)
          "
          ><b>Approve & publish </b>
        </span>
        <span
          class="
            d-inline-block
            text-primary text-uppercase
            cursor-pointer
            pl-4
            pr-4
          "
          @click="openApproval(data.item, 'approved')"
          v-if="
            (data.item.filming_complete && data.item.with_equipment != null) ||
            (data.item.has_script && data.item.with_equipment != null)
          "
        >
          <b>Approve & Pause</b>
        </span>
        <span
          class="text-danger status px-4"
          v-if="
            (!data.item.has_script && !data.item.filming_complete) ||
            data.item.with_equipment == null
          "
          ><b>ADD INFORMATION </b>
          <b-icon
            icon="exclamation-triangle-fill"
            scale=".9"
            variant="danger"
          ></b-icon>
        </span>
        <b-dropdown id="dropdown-right" right class="action-button">
          <template #button-content>
            <b-icon icon="three-dots" scale="2" class="cursor-pointer"></b-icon>
          </template>
          <b-dropdown-item @click="updateStatus(data.item, 'draft')"
            >Back to draft</b-dropdown-item
          >
        </b-dropdown>
      </template>
    </b-table>

    <h2 v-if="!searchResult" class="text-center py-5">
      No "{{ searchStr }} " found
    </h2>

    <div
      class="
        pagination-wrapper
        d-flex
        justify-content-between
        align-items-center
        w-100
      "
      v-if="searchResult"
    >
      <div class="total">{{ currentDataList.count }} results</div>
      <div class="pagination">
        <ul
          role="menubar"
          aria-disabled="false"
          aria-label="Pagination"
          class="pagination b-pagination"
          v-if="countPage() != 1"
        >
          <li
            role="presentation"
            aria-hidden="true"
            class="page-item cursor-pointer"
            v-if="currentDataList.previous"
          >
            <span
              aria-label="Go to previous page"
              class="page-link text-primary"
              @click="prev()"
            >
              <b-icon icon="chevron-left" aria-hidden="true"></b-icon
            ></span>
          </li>
          <li
            class="page-item"
            v-for="item in countPage()"
            :key="item"
            :class="item == currentPaginationPage ? 'active' : ''"
          >
            <button class="page-link" @click="page(item)">{{ item }}</button>
          </li>
          <li
            role="presentation"
            aria-hidden="true"
            class="page-item cursor-pointer"
            v-if="currentDataList.next"
          >
            <span
              aria-label="Go to next page"
              class="page-link text-primary"
              @click="next()"
            >
              <b-icon icon="chevron-right" aria-hidden="true"></b-icon
            ></span>
          </li>
        </ul>
      </div>
      <div
        class="
          dropdown-pagination
          d-flex
          justify-content-end
          align-items-center
        "
      >
        <b-form-group class="select">
          <b-form-select v-model="limit" @change="changelimit()">
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </b-form-select>
        </b-form-group>
        Per page
      </div>
    </div>
    <approval-modal> </approval-modal>
  </div>
</template>